import { httpClient } from '@/services/http/httpClient'
import { getTenantByCookies } from '@/utils/getTenantByCookies'

type FinancialCostsRevenues = {
  costReductionEstimated: number
  costReductionValidated: number
  revenueGainEstimated: number
  revenueGainValidated: number
}

type Response = {
  financialCostsRevenues: FinancialCostsRevenues
}

async function getDashboardFinancialCostsRevenues(): Promise<Response> {
  const tenant = await getTenantByCookies()

  if (tenant?.slug === 'trial') {
    return {
      financialCostsRevenues: {
        costReductionEstimated: 10,
        costReductionValidated: 20,
        revenueGainEstimated: 30,
        revenueGainValidated: 15,
      },
    }
  }

  const { data } = await httpClient.get<FinancialCostsRevenues>(
    '/ideas/dashboard/financial-impact',
  )

  return {
    financialCostsRevenues: data,
  }
}

export { getDashboardFinancialCostsRevenues, type FinancialCostsRevenues }
